module.exports = __webpack_public_path__ + "img/image2.f406da39.jpg";